import { render, staticRenderFns } from "./numCont.vue?vue&type=template&id=dd3f87a4&scoped=true"
import script from "./numCont.vue?vue&type=script&lang=js"
export * from "./numCont.vue?vue&type=script&lang=js"
import style0 from "./numCont.vue?vue&type=style&index=0&id=dd3f87a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3f87a4",
  null
  
)

export default component.exports